<template>
  <t-card max-width="600">
    <v-card-title>
      <v-row class="py-4 px-4">
        <v-col>
          <span v-if="dialog.config.hasTitle">RECUPERAÇÃO DE SENHA</span>
        </v-col>
        <v-spacer />
        <v-btn v-if="dialog.config.hasCloseButton" icon elevation="0">
          <v-icon size="small" @click="close">
            mdi-close
          </v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row justify="center" class="my-4">
        <v-col
          cols="8"
          sm="5"
          md="4"
          lg="6"
        >
          <t-logo width="100%" />
        </v-col>
      </v-row>
      <v-stepper v-model="step" elevation="0" style="background: transparent">
        <v-stepper-header style="box-shadow: none; border-bottom: 1px solid orange">
          <v-stepper-item v-for="_step in steps" :key="_step.id" :value="_step.id" />
        </v-stepper-header>
        <v-stepper-window>
          <v-stepper-window-item v-for="_step in steps" :key="_step.id" :value="_step.id">
            <component
              :is="_step.component"
              v-model="user"
              :token="token"
              :methods="methods"
              :selected-method="selectedMethod"
              @submit="validate"
              @return="() => step--"
            />
          </v-stepper-window-item>
        </v-stepper-window>
      </v-stepper>
    </v-card-text>
  </t-card>
</template>

<script setup lang="ts">
import { ref } from "vue";

import User from "@/types/User";

import TCard from "@/components/core/TCard.vue";
import { PasswordToken } from "@/api/requests/getPasswordRecoveryToken";
import TLogo from "@/components/core/TLogo.vue";
import FormGetRecoverCode from "@/components/User/FormGetRecoverCode.vue";
import FormValidateRecoverCode from "@/components/User/FormValidateRecoverCode.vue";
import FormRecoverPassword from "@/components/User/FormRecoverPassword.vue";
import FormSearchAccount from "@/components/User/FormSearchAccount.vue";
import RecoveryMethod from "@/types/RecoveryMethod";
import { useDialog } from "@/stores/dialog";
import { useSnackbar } from "@/stores/snackbar";

defineOptions({
  name: "PasswordRecover",
});

// Get global properties
const dialog = useDialog();
const snackbar = useSnackbar();

// Reactive state
const user = ref<User>({} as User);
const step = ref(1);
const steps = ref([
  {
    id: 1,
    name: "Encontrar sua conta",
    component: FormSearchAccount,
  },
  {
    id: 2,
    name: "Escolher método de identificação",
    component: FormGetRecoverCode,
  },
  {
    id: 3,
    name: "Validar identificação",
    component: FormValidateRecoverCode,
  },
  {
    id: 4,
    name: "Escolher nova senha",
    component: FormRecoverPassword,
  },
]);
const token = ref<PasswordToken>({} as PasswordToken);
const methods = ref<RecoveryMethod[]>([]);
const selectedMethod = ref<RecoveryMethod>({} as RecoveryMethod);

// Methods
async function validate($event: PasswordToken | RecoveryMethod | RecoveryMethod[]): Promise<void> {
  const stepHandlers: Record<number, () => boolean | Promise<boolean | void>> = {
    [1]: () => {
      methods.value = $event as RecoveryMethod[];
      return true;
    },
    [2]: () => {
      selectedMethod.value = $event as RecoveryMethod;
      return true;
    },
    [3]: () => {
      token.value = $event as PasswordToken;
      return true;
    },
    [4]: () => submit(),
  };

  const valid = !stepHandlers[step.value] || (await stepHandlers[step.value]());

  if (!valid) return;

  step.value++;
}

function close() {
  dialog.hide();
}

function submit() {
  snackbar.show("Senha alterada com sucesso!", "success");
  close();
  return true;
}
</script>
